export default __webpack_public_path__ + "static/media/hero-img-carverify.34a063ef.png";